import type { components } from '#open-fetch-schemas/api'

export type TournamentType = components['schemas']['TournamentType']

export function useEnumTournamentType() {
  const { t } = useI18n()

  function getLabel(type: TournamentType): string {
    switch (type) {
      case 'solos':
        return t('Solo')
      case 'couples':
        return t('Couples')
      default:
        return ''
    }
  }

  function tournamentTypeAsOptions(): Array<{ value: string, label: string }> {
    return [{
      value: 'solos',
      label: getLabel('solos'),
    }, {
      value: 'couples',
      label: getLabel('couples'),
    }]
  }

  return { getLabel, tournamentTypeAsOptions }
}
